import { Checkbox, FormControlLabel, Stack, TextField } from "@mui/material";
import { ChangeEvent, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAnswer } from "src/context/AnswerProvider";
import { useQuestions } from "src/context/QuestionsProvider";

import { useSubmitAnswers } from "src/hooks/useSubmitAnswers";

const QuestionText = () => {
  const { answers, setAnswers } = useAnswer();
  const page = "questions";
  const { t } = useTranslation();
  const defaultAnswer = useQuestions((q) => q.options?.[0]);
  const { submitAnswer } = useSubmitAnswers();

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setAnswers([event.target.value]);
    },
    [setAnswers],
  );

  const handleOnCheck = useCallback(
    (isChecked: boolean) => {
      if (isChecked) {
        const checkedAnswer = [defaultAnswer?.label ?? ""];
        setAnswers(checkedAnswer);

        submitAnswer(checkedAnswer);
      } else {
        setAnswers([]);
      }
    },
    [defaultAnswer, setAnswers, submitAnswer],
  );

  const isChecked = useMemo(
    () => answers[0] === defaultAnswer?.label,
    [answers, defaultAnswer],
  );

  return (
    <Stack gap={1}>
      <TextField
        value={answers[0] ?? ""}
        onChange={handleChange}
        fullWidth
        multiline
        minRows={5}
        placeholder={t(`${page}.placeholder.text`)}
        style={{ borderRadius: "8px" }}
      />
      {defaultAnswer ? (
        <FormControlLabel
          sx={{ alignItems: "start", gap: 1, margin: 0 }}
          control={
            <Checkbox
              checked={isChecked}
              onChange={(e) => handleOnCheck(e.target.checked)}
              sx={{
                padding: 0,
                "&.Mui-checked": {
                  color: "#FF8175",
                },
              }}
            />
          }
          label={defaultAnswer.label}
        />
      ) : null}
    </Stack>
  );
};

export default QuestionText;
